import { createAction, createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxRootState } from "../../shared/redux/store";
import { ReduxSliceState } from "../../shared/types";
import { withPayloadType } from "../../shared/utils";
import { KitItem } from "../../api/types";
import { LoadKitProps, LoadKitsProps, ReduxKitsState } from "../types";

const initialState: ReduxKitsState = {
    state: 'BUSY',
    kits: [],
    selectedKit: undefined,
    statusFilter: undefined,
};

export const loadKits = createAction('kits/loadKits', withPayloadType<LoadKitsProps>());
export const loadKit = createAction('kits/loadKit', withPayloadType<LoadKitProps>());

const kitsSlice = createSlice({
    name: 'kits',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setKits: (state, action: PayloadAction<KitItem[]>) => {
            state.kits = action.payload;
        },
        setSelectedKit: (state, action: PayloadAction<KitItem | undefined>) => {
            state.selectedKit = action.payload;
        },
        setStatusFilter: (state, action: PayloadAction<string | undefined>) => {
            state.statusFilter = action.payload;
        },
    }
});

export default kitsSlice;

const selectSelf = (state: ReduxRootState) => state.kits;
export const selectKitsIsBusy = createSelector(selectSelf, self => self.state === 'BUSY');
export const selectKits = createSelector(selectSelf, self => self.kits);
// displayStatus (server-computed - see KitsController.ApplyDisplayStatusAsync) reflects the
// real-world state: null/'SHIPPED' (not yet delivered) or 'DELIVERED' both still count as
// "available to use" - only 'USED' (already submitted against a patient order) doesn't. The raw
// `status` field alone can't tell delivered-but-unused apart from delivered-and-used.
export const selectKitsHasUnusedKit = createSelector(selectKits, kits => kits.some(kit => kit.displayStatus !== 'USED'));
export const selectSelectedKit = createSelector(selectSelf, self => self.selectedKit);
export const selectKitsStatusFilter = createSelector(selectSelf, self => self.statusFilter);
